import type { AuthorResponseRecord, HeadlineResponsePagedData } from '@on3/api';
import { FeedList } from '@public/components/Headlines/ArticleFeed/FeedList';
import { Pagination } from '@public/components/UI/Pagination/Pagination';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

import { AuthorBio } from './AuthorBio';

export interface IAuthorFeedProps {
  userArticles: HeadlineResponsePagedData | null;
  userProfileResponse: AuthorResponseRecord | null;
}

export const AuthorFeed = ({
  userProfileResponse: userProfileRespones,
  userArticles,
}: IAuthorFeedProps) => {
  const { list, pagination } = userArticles || {};

  const [pageNumber, setPageNumber] = useState(pagination?.currentPage);
  const router = useRouter();
  const hasPagination = pagination?.count && pagination?.count > 25;

  const handleChange = useCallback(
    (event: any, value: any) => {
      setPageNumber(value);
      router.push({
        pathname: router.pathname,
        query: { ...router.query, page: value },
      });
    },
    [router],
  );

  return (
    <div>
      {userProfileRespones && <AuthorBio author={userProfileRespones.author} />}
      {!!hasPagination && (
        <Pagination
          count={pagination?.pageCount}
          onChange={handleChange}
          page={pageNumber}
        />
      )}
      {!!list?.length && <FeedList list={list} />}
      {!!hasPagination && (
        <Pagination
          count={pagination?.pageCount}
          onChange={handleChange}
          page={pageNumber}
        />
      )}
    </div>
  );
};
